export default __webpack_public_path__ + "static/media/nutsandboltmf (1).7e6dfd5d.svg";